export type {
  TeachingPopoverBodyProps,
  TeachingPopoverBodySlots,
  TeachingPopoverBodyState,
} from '@fluentui/react-teaching-popover';
